module.exports = __webpack_public_path__ + "img/input-error.68987fbf.svg";